module.exports = "/_next/static/images/5932f68e90e55c278ae3eb81a26220af-Nubank_HickDuarte_57380_md.png.webp";